const initializeSupportButtonLabel = (current_person) => {
  if ($(".jsSupportButton")) {
    const current_person_id = current_person ? current_person.id : 0;
    const support_button = document.getElementsByClassName("jsSupportButton");
    const len = support_button.length;
    if (len > 0) {
      const user_id = support_button[0].dataset.userId;
      for (let i = 0; i < len; i += 1) {
        const support_button_event_label = `user_${user_id}_person_${current_person_id}`;
        support_button[i].dataset.label = support_button_event_label;
      }
    }
  }
};

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default initializeSupportButtonLabel;